import type { Answer } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { cacheKeyFor, type Store } from '@warp-drive/core';
import {
  createRecord,
  query,
  updateRecord,
} from '@warp-drive/utilities/json-api';

import { jsonApiOptions, page } from '../../json-api.ts';

export function queryQuizAnswer(userId: string, quizId: string) {
  return query<Answer>(
    DataTypeQuiz.Answer,
    {
      'filter[user]': userId,
      'filter[quiz.id]': quizId,
      ...page({ offset: 0, limit: 1 }),
    },
    jsonApiOptions
  );
}

export function upsertAnswer(answer: Answer, store: Store) {
  const init = answer.isNew
    ? createRecord(answer, {
        ...jsonApiOptions,
      })
    : updateRecord(answer, {
        ...jsonApiOptions,
        patch: true,
      });

  init.body = JSON.stringify({
    data: store.cache.peek(cacheKeyFor(answer)),
  });

  init.headers.set('Content-Type', 'application/vnd.api+json');
  return init;
}
